import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Countries } from "../countries/countries.entity";
import { Destination } from "../destination/destination.entity";
import { FreightsCompany } from "../freights-company/freights-company-entity";
import { OcaenFreightRateLogsEntity } from "./ocaen-freight-rates-log-entity";

@Entity('ocaen_freight_rates')
export class OcaenFreightRatesEntity {

  @PrimaryGeneratedColumn("increment",{name:'id'})
  id:number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "basic_price"
  })
  basicPrice: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "other_charge"
  })
  otherCharge: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "total"
  })
  total: number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type=>Countries, e=>e.ocaenFreightsInfo,{  nullable:false, })
  @JoinColumn({ name:"country_id"})
  countryInfo: Countries;

  @ManyToOne(type=>Destination, e=>e.ocaenFreightsInfo,{  nullable:false, })
  @JoinColumn({ name:"destination_id"})
  destinationInfo: Destination;

  @ManyToOne(type=>FreightsCompany, e=>e.ocaenFreightsInfo,{  nullable:false, })
  @JoinColumn({ name:"liner_id"})
  linerInfo: FreightsCompany;

  @OneToMany(type => OcaenFreightRateLogsEntity, info => info.oceanFreight, { cascade: true })
  ocaenFreightsInfo: OcaenFreightRateLogsEntity[];
}
